import React, { ReactNode } from 'react'

import { Tabs } from 'antd'
import { TabsProps } from 'antd/lib/tabs/index'

import './DataDisplay.less'

const { TabPane } = Tabs

interface Props extends TabsProps {
  panes?: TabPaneProps[]
}

export interface TabPaneProps {
  key: string
  title: string | ReactNode
  content: ReactNode
  closable?: boolean
  disabled?: boolean
}

const Display: React.FC<Props> = (props) => {
  return (
    <Tabs {...props}>
      {props.panes &&
        props.panes.map((pane) => (
          <TabPane
            tab={pane.title}
            key={pane.key}
            closable={props.type !== 'editable-card' || pane.closable === undefined ? false : pane.closable}
            disabled={pane.disabled}
          >
            {pane.content}
          </TabPane>
        ))}

      {props.children && props.children}
    </Tabs>
  )
}

export default Display
